import { useEffect, useRef, useState } from "react";
import { register, call, remove } from "../../funcStore";
import FilterGroup from "./FilterGroup";
import { NameInput } from "./NameInput";
import { FILTER_GROUPS } from "../../data/filterGroups";

const styles = {
  filterPanel: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    width: "240px",
    flexShrink: 0,
    background: "#fff",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  spFilterPanel: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 100,

    display: "flex",
    flexDirection: "column",

    height: "50%",
    boxSizing: "border-box",

    background: "#fff",
    padding: "16px",
    borderRadius: "12px 12px 0 0",
    boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.15)",
  },

  spFilterContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",

    flex: 1,
    minHeight: 0,
    overflowY: "auto",
  },

  submitArea: {
    flexShrink: 0,
    backgroundColor: "white",
    paddingTop: "8px",
    display:"flex",
    gap:8,
    height:40
  },

  submitButton: {
    padding: "10px",
    border: "none",
    borderRadius: "4px",
    background: "#4b3f8f",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
    width: "100%",
    flex:3
  },
  closeButton: {
    padding: "10px",
    border: "none",
    borderRadius: "4px",
    background: "#bfbec4",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer",
    width: "100%",
    flex:1
  },
  submitButtonDisabled: {
    opacity: 0.6,
    cursor: "default",
  },
};

function FilterSelector() {
  const COMPONENT_KEY = "filterSelector";

  //state
  const STATE_BEFORE_INIT = "beforeInit";
  const STATE_IDLE = "idle";
  const STATE_SEARCHING = "searching";
  const STATE_CLOSING = "close";

  const [state, setState] = useState(STATE_BEFORE_INIT);

  const stateRef = useRef(state);
  stateRef.current = state;

  //data
  const dataRef = useRef({
    mobile: "pc",
  });

  //effect
  useEffect(() => {
    if (state === STATE_BEFORE_INIT) {
      dataRef.current.mobile = call("PCSP.getState");

      register(`${COMPONENT_KEY}.getState`, () => stateRef.current);

      register(`${COMPONENT_KEY}.setSearching`, () => {
        if ((stateRef.current === STATE_SEARCHING || stateRef.current === STATE_CLOSING) && dataRef.current.mobile === "sp") {
          setState(STATE_CLOSING);
        }else{
          setState(STATE_IDLE)
        }
      });

      setState(STATE_IDLE);
    }
    if (state === STATE_SEARCHING) {
      call("searchPage.clickSearch");
    }
  }, [state]);

  useEffect(() => {
    return () => {
      remove(`${COMPONENT_KEY}.getState`);
      remove(`${COMPONENT_KEY}.setSearching`);
    };
  }, []);

  //render
  if (state === STATE_BEFORE_INIT || state === STATE_CLOSING) {
    return (
      <button
        type="submit"
        style={{
          position: "fixed",
          bottom: 10,
          left: 10,
          borderRadius: "4px",
          background: "#9081e6",
          zIndex:100,
          border:"none",
          width:150,
          height:40
        }}
        onClick={() => setState(STATE_IDLE)}
      >
        検索条件を設定する
      </button>
    );
  }

  return (
    <div
      style={
        dataRef.current.mobile === "pc"
          ? styles.filterPanel
          : styles.spFilterPanel
      }
    >
      <div style={styles.spFilterContent}>
        <NameInput />

        {FILTER_GROUPS.map((group) => (
          <FilterGroup key={group.key} groupKey={group.key} />
        ))}
      </div>

      <div style={styles.submitArea}>
        <button
          type="submit"
          style={{
            ...styles.submitButton,
            ...(state === STATE_SEARCHING ? styles.submitButtonDisabled : {}),
          }}
          disabled={state === STATE_SEARCHING}
          onClick={() => setState(STATE_SEARCHING)}
        >
          {state === STATE_SEARCHING ? "検索中..." : "検索"}
        </button>
        {dataRef.current.mobile == "sp" && <button
          type="submit"
          style={{
            ...styles.closeButton,
          }}
          disabled={state === STATE_SEARCHING}
          onClick={() => setState(STATE_CLOSING)}
        >
          閉じる
        </button>}
      </div>
    </div>
  );
}

export default FilterSelector;
